
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {unsubscribe as unsubscribeAction} from 'redux/modules/unsubscribe/actions'
import {connect} from 'react-redux'
import Logo from 'components/Logo'

class UnsubscriptionView extends React.Component {
  static propTypes = {
    isFetching: PropTypes.bool.isRequired,
    secretType: PropTypes.string,
    secret: PropTypes.string,
    unsubscribe: PropTypes.func.isRequired,
    successMessage: PropTypes.string,
    errorMessage: PropTypes.string
  }

  static defaultProps = {
    successMessage: '',
    errorMessage: ''
  }

  componentDidMount() {
    const {unsubscribe, secretType, secret} = this.props

    unsubscribe(secret, secretType)
  }

  render() {
    return (
      <div className='unsubscribe-view'>
        <div className='unsubscribe-view_logo_container'>
          <Logo
            inverted
            link
            className='unsubscribe-view_logo'
            size='medium'
          />
        </div>
        <div className='unsubscribe-view_content'>
          <p>{this.renderContent()}</p>
        </div>
      </div>
    )
  }

  renderContent() {
    const {successMessage, errorMessage, isFetching} = this.props

    if (isFetching) {
      return 'Unsubscription is in progress...'
    }

    if (errorMessage) {
      return <span className='error'>{errorMessage}</span>
    }

    if (successMessage) {
      return <span className='success'>{ successMessage }</span>
    }

    return null
  }
}

const mapStateToProps = (state, props) => {
  const {location: {query}} = props
  const {type: secretType, secret} = query
  const {
    isFetching,
    successMessage,
    errorMessage
  } = state.unsubscribe

  return {
    isFetching,
    secretType,
    secret,
    successMessage,
    errorMessage
  }
}

const mapDispatchToProps = {
  unsubscribe: unsubscribeAction
}

export default connect(mapStateToProps, mapDispatchToProps)(UnsubscriptionView)



// WEBPACK FOOTER //
// ./client/views/UnsubscribeView/index.js